// extracted by mini-css-extract-plugin
export default {"wrapper":"Contact_wrapper__fIr3s","username":"Contact_username__Z70UH","email":"Contact_email__Z0xBO","message":"Contact_message__fH0MQ","btn-send":"Contact_btn-send__Uxj9A"};